export default {
  title: {
    text: "全球湿化学品市场规模",
    left: "center",
    textStyle: {},
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      crossStyle: {
        color: "#999",
      },
    },
  },
  grid: {
    top: 90,
  },
  toolbox: {
    feature: {
      dataView: { show: false, readOnly: false },
      magicType: { show: false, type: ["line", "bar"] },
      restore: { show: false },
    },
  },
  legend: {
    top: 50,
    left: "center",
    data: ["全球半导体用湿化学品市场规模", "同比"],
  },
  xAxis: [
    {
      type: "category",
      data: ["2013", "2014", "2015", "2016", "2017", "2018"],
      axisPointer: {
        type: "shadow",
      },
      axisLabel: {
        formatter: "{value}",
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "亿美元",
      nameTextStyle: {
        align: "right",
      },
      min: 0,
      max: 18,
      interval: 3,
      axisLabel: {
        formatter: "{value}",
      },
    },
    {
      type: "value",
      name: "同比",
      nameTextStyle: {
        align: "left",
      },
      min: -3,
      max: 9,
      interval: 3,
      axisLabel: {
        formatter: "{value} %",
      },
    },
  ],
  series: [
    {
      name: "全球半导体用湿化学品市场规模",
      type: "bar",
      barWidth: 15,
      data: [13.0, 13.4, 14.0, 13.6, 15.2, 17.0],
    },
    {
      name: "同比",
      type: "line",
      yAxisIndex: 1,
      data: ["undefined", 1, 4, -2, 6, 7],
    },
  ],
};
